// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3kVrw","actions":"GroupTable_actions__3P2E5","deleteModalFooter":"GroupTable_deleteModalFooter__ntziL"};